import { Palmtree, Stethoscope, CalendarOff, Clock } from "lucide-react";

// Stile coerente con Orbit per la fascia di assenza sovrapposta all'Agenda.
const ABS_STYLE = {
  ferie: { bg: "bg-emerald-50", border: "border-emerald-300", text: "text-emerald-800", dot: "bg-emerald-500", icon: Palmtree, label: "FERIE" },
  permesso: { bg: "bg-sky-50", border: "border-sky-300", text: "text-sky-800", dot: "bg-sky-500", icon: CalendarOff, label: "PERMESSO" },
  malattia: { bg: "bg-rose-50", border: "border-rose-300", text: "text-rose-800", dot: "bg-rose-500", icon: Stethoscope, label: "MALATTIA" },
  _special: { bg: "bg-violet-50", border: "border-violet-300", text: "text-violet-800", dot: "bg-violet-500", icon: CalendarOff },
};

const styleFor = (a) => ABS_STYLE[a.causale] || ABS_STYLE._special;

export const hasFullDayAbsence = (absences) => (absences || []).some((a) => a.full_day);

// Fasce di assenza (giornata intera + orarie) mostrate sopra i servizi del giorno.
export function AbsenceBands({ absences }) {
  if (!absences || absences.length === 0) return null;
  return (
    <div className="space-y-1.5 mb-2" data-testid="agenda-absence-bands">
      {absences.map((a, i) => {
        const st = styleFor(a);
        const Icon = st.icon;
        const label = ABS_STYLE[a.causale]?.label || (a.label || "PERMESSO SPECIALE").toUpperCase();
        return (
          <div key={i} data-testid={`agenda-absence-${a.causale}-${a.full_day ? "day" : "hour"}`}
            className={`flex items-center gap-2 rounded-lg border-l-4 ${st.border} ${st.bg} px-3 py-2`}>
            <Icon className={`h-4 w-4 ${st.text} shrink-0`} />
            <span className={`text-xs font-bold tracking-wide ${st.text}`}>{label}</span>
            {a.full_day ? (
              <span className={`text-[11px] ${st.text} opacity-80`}>· giornata intera</span>
            ) : (a.start_time && a.end_time) ? (
              <span className={`inline-flex items-center gap-1 text-[11px] ${st.text} opacity-80`}>
                · <Clock className="h-3 w-3" />{a.start_time}–{a.end_time}
              </span>
            ) : null}
          </div>
        );
      })}
    </div>
  );
}
